import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { ExpiringCredential } from '@Models';

interface CredentialsState {
  error?: string;
  isFetching: boolean;
  expires_credentials: ExpiringCredential[];
}

const initialState: CredentialsState = {
  error: undefined,
  isFetching: false,
  expires_credentials: [],
};

const reducers = {
  fetchExpiringCredentialsFailure: (state: CredentialsState, action: PayloadAction<{ error: string }>) => {
    const { error } = action.payload || {};
    state.error = error;
    state.isFetching = false;
  },

  fetchExpiringCredentialsRequest: (state: CredentialsState) => {
    state.error = undefined;
    state.isFetching = true;
  },

  fetchExpiringCredentialsSuccess: (
    state: CredentialsState,
    action: PayloadAction<{ credentials: ExpiringCredential[] }>,
  ) => {
    const { credentials } = action.payload || {};
    state.expires_credentials = credentials;
    state.isFetching = false;
  },
};

const slice = createSlice({ initialState, name: 'credentials', reducers });

export const { actions } = slice;
export default slice.reducer;
